import request from '@/utils/request'
import {
    getEnv
} from '@/utils/host'
import {
    leftPad,
    arrayify
} from '../utils/BaseUtil'
const secp256k1 = new Ec('secp256k1')
import {
    ec as Ec
} from 'elliptic'
import ThkAddress from '../utils/ThkAddress'
var util = require('ethereumjs-util');

export function login(username, password) {
    return request({
        url: '/v1/login',
        method: 'post',
        data: {
            "username": username,
            "password": password,
            "captchaKey": "b4193f6c-921f-48ea-8850-5c4364a4431c",
            "captcha": "admin"
        }
    })
}
// 使用浏览器接口注册合约
export function RegistrationContract(data) {
    let Env = getEnv()
    console.log("当前环境", Env)
    let href = window.location.href;
    let url
    if (Env == 'dev') {
        console.log("测试用测试浏览器", href)
        url = 'http://browser.chainopen.cn/browser-api'
    } else {
        url = 'https://www.thinkiumscan.net/browser-api'
    }
    return request({
        baseURL: url,
        url: '/v1/registerContract',
        method: 'post',
        data
    })
}
export function logout() {
    return request({
        url: '/v1/logout',
        method: 'get',
        params: {}
    })
}
//获取导航栏列表
export function getnavMenuList() {
    return request({
        url: '/v1/permission/listPermissionByLoginUser',
        method: 'post',
    })
}


//获取所有RPC服务
export function getrpcserver() {
    return request({
        url: '/v1/chain/getrpcserver',
        method: 'get',
        params: {}
    })
}

//获取RPC对应的链
export function getchaininfo(data) {
    return request({
        url: '/v1/chain/getchaininfo',
        method: 'post',
        data: data
    })
}
//获取xto环境
export function getenvList(data) {
    return request({
        url: '/v1/xto/env/list/get',
        method: 'get',

    })
}
//获取系统
export function getappList(data) {
    return request({
        url: '/v1/xto/app/list/get',
        method: 'get',

    })
}

//获取合约
export function getcontractList(data) {
    return request({
        url: '/v1/xto/contract/list/get',
        method: 'post',
        data,

    })
}



//根据hash查交易
export function getTransactionByHash(data, contractType) {
    return request({
        url: `/v1/chain/getTransactionByHash${contractType}`,
        method: 'post',
        data: data
    })
}

//获取用户列表
export function userlList(data) {
    return request({
        url: '/v1/user/list',
        method: 'post',
        data: data
    })
}
//创建用户 
export function createUser(data) {
    return request({
        url: '/v1/user/save',
        method: 'post',
        data: data
    })
}
//获取账户余额
export function getaccount(data) {
    return request({
        url: '/v1/chain/getaccount',
        method: 'post',
        data: data
    })
}

//获取账户余额
export function chainSendTx(data) {
    return request({
        url: '/v1/chain/sendTx',
        method: 'post',
        data: data
    })
}
// 批量转账
export function chainSendTxBatch(data) {
    return request({
        url: '/v1/chain/sendTxBatch',
        method: 'post',
        data: data
    })
}

//查询交易log
export function transferList(data) {
    return request({
        url: '/v1/transfer/list',
        method: 'post',
        data: data
    })
}
//xto同步芯客
export function syncXinke() {
    return request({
        url: '/v1/xto/contract/xinke/sync',
        method: 'get',
    })
}
//生成sig
export function createSig(data) {
    return request({
        url: '/v1/chain/create/sig',
        method: 'post',
        data: data
    })
}

//生成sig
export function sendTxSig(data) {
    return request({
        url: '/v1/chain/sendTx/sig',
        method: 'post',
        data: data
    })
}

//生成key
export function getkey() {
    return request({
        url: '/v1/key/getkey',
        method: 'post',
    })
}

//生成key
export function encryptAddress(data) {
    return request({
        url: '/v1/key//encrypt/to/address',
        method: 'post',
        data: data
    })
}

//获取合约
export function contractList() {
    return request({
        url: '/v1/contract/list',
        method: 'get',
        params: {}
    })
}

//获取合约
export function unpackInput(data) {
    return request({
        url: '/v1/contract/input/unpack',
        method: 'post',
        data: data
    })
}

//获取合约
export function contractDeploy(data) {
    return request({
        url: '/v1/contract/deploy',
        method: 'post',
        data: data
    })
}

//获取合约
export function usercontract(data) {
    return request({
        url: '/v1/usercontract/list',
        method: 'post',
        data,
    })
}

//获取合约xto个数
export function getxtocount(data) {
    return request({
        url: '/v1/xto/getxtocount',
        method: 'post',
        data: data
    })
}


//获取合约
export function creationAccount(data) {
    return request({
        url: '/v1/xto/creation/account',
        method: 'post',
        data: data
    })
}

//获取合约
export function signedS(data) {
    return request({
        url: '/v1/xto/signed/send',
        method: 'post',
        data: data
    })
}
//转账发奖
export function signedSend(data) {
    return request({
        url: '/v1/xto/signed/send',
        method: 'post',
        data: data
    })
}
//获取合约内用户集合
export function getUserCollection(data) {
    return request({
        url: '/v1/xto/contract/user/list/get',
        method: 'post',
        data: data,
    })
}

//获取合约
export function sendAward(data) {
    return request({
        url: '/v1/xto/contract/send/award',
        method: 'post',
        data: data
    })
}

//获取合约
export function createNode(data) {
    return request({
        url: '/v1/node/create',
        method: 'post',
        data: data
    })
}

//获取合约
export function addNode(data) {
    return request({
        url: '/v1/node/add',
        method: 'post',
        data: data
    })
}

//获取合约
export function listNode(data) {
    return request({
        url: '/v1/node/list',
        method: 'post',
        data: data
    })
}

//获取合约
export function delNode(data) {
    return request({
        url: '/v1/node/del',
        method: 'post',
        data: data
    })
}

//获取合约
export function logNodeList(data) {
    return request({
        url: '/v1/node/log/list',
        method: 'post',
        data: data
    })
}

//获取合约
export function transferPledge(data) {
    return request({
        url: '/v1/transfer/pledge',
        method: 'post',
        data: data
    })
}

//查询合约模板方法集合
export function getContractFnList(params) {
    return request({
        url: '/v1/contract/func/list',
        method: 'get',
        params,
    })
}

//新增合约模板
export function addContract(data) {
    return request({
        url: '/v1/contract/add',
        method: 'post',
        data,
    })
}

//更新合约模板
export function updateContract(data) {
    return request({
        url: '/v1/contract/update',
        method: 'post',
        data,
    })
}

//发起交易
export function contractTransfer(data) {
    return request({
        url: '/v1/contract/transfer',
        method: 'post',
        data,
    })
}
//获取合约
export function getxtocountAddress(data) {
    return request({
        url: '/v1/xto/getxtocount/address',
        method: 'post',
        data: data
    })
}
//账号同步
export function getpageAccount(data) {
    return request({
        url: '/v1/account/pageAccount',
        method: 'post',
        data: data
    })
}
//同步芯客 merchantAccount
export function syncXkMerchantAccount(data) {
    return request({
        url: '/v1/account/syncXkMerchantAccount',
        method: 'post',
        data: data
    })
}

//同步芯客 Project
export function syncXkProject(data) {
    return request({
        url: '/v1/account/syncXkProject',
        method: 'post',
        data: data
    })
}

//查询交易数据
export function searchTransaction(data, baseURL) {
    return request({
        baseURL,
        url: '/v1/tradingList',
        method: 'post',
        data,
    })
}
//报告列表
export function getStrategyShow(data, baseURL) {
    return request({
        baseURL,
        url: '/monitor/strategy/show',
        method: 'post',
        data,
    })
}
//打开或下载 txt、csv
export function getStrategyView(data, baseURL) {
    console.log(baseURL, data, 11111)
    return request({
        baseURL,
        url: '/monitor/strategy/view',
        method: 'post',
        data,
    })
}

//打开报告
export function exportReport(baseURL, query) {
    console.log(query)
    return request({
        baseURL,
        url: `/monitor/strategy/exportReport/${query}`,
        method: 'get',
    })
}
//填写获取XTO 
export function newGetxtoCount(data) {
    return request({
        url: `/v1/xto/new/getxtocount`,
        method: 'post',
        data,
    })
}
//保存合约测试用例
export function saveContractCase(data) {
    return request({
        url: `/v1/contract/case/save`,
        method: 'post',
        data,
    })
}
//查询用例集合
export function getContractCase(data) {
    return request({
        url: `/v1/contract/case/get`,
        method: 'post',
        data,
    })
}


//更新/删除用例
export function updateContractCase(data) {
    return request({
        url: `/v1/contract/case/update`,
        method: 'post',
        data,

    })
}

//保存策略用例
export function saveExample(data, baseURL) {
    return request({
        baseURL,
        url: `/monitor/strategy/saveExample`,
        method: 'post',
        data,
    })
}

//查看策略用例
export function getExample(data, baseURL) {
    return request({
        baseURL,
        url: `/monitor/strategy/listExample`,
        method: 'post',
        data,

    })
}

//动态sdk文档
export function getSdkList() {
    return request({
        url: `/v1/sdk/list`,
        method: 'get',

    })
}




export function SignTransaction(transaction, privateKey) {
    const signedTransaction = transaction;
    let privateKeyss = arrayify(privateKey);
    // console.log('#################privateKey=', privateKey)

    if (!privateKey) throw new Error('Private key not found')
    const keyPair = secp256k1.keyFromPrivate(privateKeyss)

    const toaddr = signedTransaction.to.substring(0, 2) === '0x' ? signedTransaction.to.substring(2) : signedTransaction.to
    const fromaddr = signedTransaction.from.substring(0, 2) === '0x' ? signedTransaction.from.substring(2) : signedTransaction.from
    let input = ""
    if (signedTransaction.input !== "") {
        input = signedTransaction.input.substring(0, 2) === '0x' ? signedTransaction.input.substring(2) : signedTransaction.input
    }

    let useLocal_str = "0"
    if (signedTransaction.useLocal) {
        useLocal_str = "1"
    } else {
        signedTransaction.useLocal = false
    }

    let signStr = signedTransaction.chainId + "-" + fromaddr.toLowerCase() + "-" +
        toaddr.toLowerCase() + "-" + signedTransaction.nonce + "-" +
        useLocal_str + "-" + signedTransaction.value + "-" + input

    signStr = signStr + '-';
    if (signedTransaction.extra && signedTransaction.extra.length > 0) {
        signStr = signStr + signedTransaction.extra.toString('hex')
    } else if (!signedTransaction.extra) {
        signedTransaction.extra = ''
    }

    // const signStr = signedTransaction.chainId + fromaddr.toLowerCase() +
    //     toaddr.toLowerCase() + signedTransaction.nonce +
    //     signedTransaction.value + input
    const wallutils = new ThkAddress(privateKey)
    let sigbyte = wallutils.stringToByte(signStr)
    console.log("signStr", signStr)
    let sighash = wallutils.keccak256(sigbyte)
    console.log("sighash:", sighash.toString('hex'))

    let sign_byte = new Buffer(sighash.substring(2), 'hex')

    const signature = keyPair.sign(sign_byte, {
        canonical: true
    });

    console.log("signature", signature)
    signedTransaction.sig = `0x${signature.r.toString(16,64)}${signature.s.toString(16,64)}${signature.recoveryParam ? '1c' : '1b'}`
    console.log('#################signature=', signature)

    // const publicKeyConvert = `0x${keyPair.getPublic(false, 'hex')}`

    let publicKey = "0x04" + util.bufferToHex(util.privateToPublic(privateKey)).slice(2);

    // const pubKey = `0x04${wallutils.getPublicKeyToAddress(publicKeyConvert, false).slice(4)}`
    console.log('#################pubKey=', publicKey)

    signedTransaction.pub = publicKey
    console.log('#################signature=', signedTransaction.sig)

    return signedTransaction;
}